/** DNI: 8 digits + letter. NIE: X, Y or Z + 7 digits + letter. Format only. */
export const IDENTITY_DOCUMENT_INPUT_PATTERN = "^([0-9]{8}|[XYZxyz][0-9]{7})[A-Za-z]$";

export const IDENTITY_DOCUMENT_PATTERN = /^([0-9]{8}|[XYZ][0-9]{7})[A-Z]$/;

export const IDENTITY_DOCUMENT_FORMAT_MESSAGE =
  "Introduce un DNI (8 números y una letra) o un NIE (X, Y o Z, 7 números y una letra).";

/**
 * Keeps a partial DNI/NIE while typing and uppercases letters.
 * @param {unknown} raw
 * @returns {string}
 */
export function normalizeIdentityDocumentInput(raw) {
  const source = String(raw ?? "").toUpperCase();
  let result = "";

  for (const char of source) {
    if (result.length >= 9) {
      break;
    }
    if (result.length === 0) {
      if (/[0-9XYZ]/.test(char)) {
        result += char;
      }
      continue;
    }

    const isNie = /[XYZ]/.test(result[0]);
    const digits = result.replace(/\D/g, "").length;
    const maxDigits = isNie ? 7 : 8;
    const suffix = isNie ? result.slice(1) : result;
    if (/[A-Z]/.test(suffix)) {
      continue;
    }
    if (/\d/.test(char) && digits < maxDigits) {
      result += char;
      continue;
    }
    if (/[A-Z]/.test(char) && digits === maxDigits) {
      result += char;
    }
  }

  return result;
}

/**
 * @param {unknown} value
 * @returns {boolean}
 */
export function isValidIdentityDocument(value) {
  return IDENTITY_DOCUMENT_PATTERN.test(String(value ?? "").trim().toUpperCase());
}
